export const PHOTO_SEARCH_LABEL = 'Search business, medical, diverse';
export const CLEAR_BUTTON_LABEL = 'Clear photo search';

export const IMAGE_PROVIDERS = 'Pexels & Pixabay';

// The default time period for a toast componet to display the infomation.
export const TOAST_TIME = 3000;
